import { RawUnitOption } from './rawUnits';

/** Raw Unit options for boolean/integer-count tag types (alarm/mode/state) — pure catalog data, ported from `gateway-details/data/boolean-integer-units.json` (still used by v1). */
export const BOOL_INTEGER_UNITS: RawUnitOption[] = [
  { label: '', value: '' },
  { label: 'Boolean', value: 'Boolean' },
  { label: 'Integer', value: 'Integer' },
  { label: 'mg', value: 'mg' },
  { label: 'g', value: 'g' },
  { label: 'kg', value: 'kg' },
  { label: 'lbs', value: 'lbs' },
];
